import {
  string as yupString,
} from 'yup';
import { TBE_TYPES } from '../../shared/constants';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, maxLength, nullable, uniqueWith } from '../../shared/forms/validators';

const nullableWhenUS = (_, validator) =>
  validator.when(['tbeType'], {
    is: TBE_TYPES.US_TBE,
    then: yupString().nullable(),
    otherwise: yupString().required(),
  });

const legalEntityGetter = ({ formik, formContext }) => {
  const foundOption = formContext.companyCodeOptions.find(option => option.value === formik.values.companyCode);
  return foundOption ? foundOption.legalEntity : '';
};

const tbeLegalEntityGetter = ({ formik, formContext }) => {
  if (formik.values.tbeCompanyCode !== '' && formik.values.tbeCompanyCode !== null) {
    const foundOption = formContext.companyCodeOptions.find(option => option.value === formik.values.tbeCompanyCode);
    return foundOption ? foundOption.legalEntity : '';
  } else {
    const foundTBEOption = formik.values.tbeLegalEntity;
    return foundTBEOption;
  }
};

const getSchema = ({ disableRestrictedField = false }) => [
  {
    name: 'companyCode',
    component: SelectFormik,
    meta: { label: 'Company Code', optionsKey: 'companyCodeOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [
      required,
      uniqueWith(['companyCode', 'tbeCompanyCode', 'tbeType'], 'Combination of "Company Code", "TBE Company Code" and "TBE Type" already exists'),
    ] },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'legalEntity',
    component: InputFormik,
    meta: { label: 'Legal Entity', valueGetter: legalEntityGetter },
    options: { yupType: yupString(), disabledWhenEditing: true },
    additionalProps: { disabled: true },
  },
  {
    name: 'leUStaxType',
    component: SelectFormik,
    meta: { label: 'US Tax Type', optionsKey: 'usTaxTypeOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'leLocalTaxType',
    component: SelectFormik,
    meta: { label: 'Local Tax Type', optionsKey: 'localTaxTypeOptions' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [nullableWhenUS],
    },
    conditions: [{
      when: ({ formik }) => formik.values.tbeType === TBE_TYPES.US_TBE,
      then: {
        additionalProps: { clearable: true },
      },
      otherwise: {
        additionalProps: { required: true },
      },
    },
    {
      when: ({ formik, formContext }) =>
        !formContext.localTaxTypeOptions.some(option => formik.initialValues.leLocalTaxType === option.value),
      then: {
        additionalProps: (formContext, formik) => ({
          options: [
            {
              label: formik.initialValues.leLocalTaxType,
              value: formik.initialValues.leLocalTaxType,
            },
            ...formContext.localTaxTypeOptions,
          ],
        }),
      },
    }],
  },
  {
    name: 'tbeCompanyCode',
    component: SelectFormik,
    meta: { label: 'TBE Company Code', optionsKey: 'tbeCompanyCodeOptions' },
    options: { yupType: yupString(), validationRules: [
      required,
      uniqueWith(['companyCode', 'tbeCompanyCode', 'tbeType'], 'Combination of "Company Code", "TBE Company Code" and "TBE Type" already exists'),
    ] },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'tbeLegalEntity',
    component: InputFormik,
    meta: { label: 'TBE Legal Entity', valueGetter: tbeLegalEntityGetter },
    options: { disabledWhenEditing: true, yupType: yupString() },
    additionalProps: { virtualized: true },
  },
  {
    name: 'tbeType',
    component: SelectFormik,
    meta: { label: 'TBE Type', optionsKey: 'tbeTypeOptions' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [
        required,
        uniqueWith(['companyCode', 'tbeCompanyCode', 'tbeType'], 'Combination of "Company Code", "TBE Company Code" and "TBE Type" already exists'),
      ],
    },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'ownership',
    component: InputFormik,
    meta: { label: 'Ownership' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [required, maxLength(10)],
    },
    additionalProps: { required: true },
  },
  {
    name: 'activeFlag',
    component: SelectFormik,
    meta: { label: 'Active Flag', optionsKey: 'enabledFlagOptions' },
    options: {
      disabledWhenEditing: disableRestrictedField,
      yupType: yupString(),
      validationRules: [required],
    },
    additionalProps: { required: true },
  },
  {
    name: 'importStatusDetail',
    component: SelectFormik,
    meta: { label: 'Import Status', optionsKey: 'importStatusOptions' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [nullable],
    },
    additionalProps: { clearable: true },
  },
  {
    name: 'importValidation',
    component: InputFormik,
    meta: { label: 'Import Note' },
    options: {
      disabledWhenEditing: disableRestrictedField,
      yupType: yupString(),
      validationRules: [maxLength(256)],
    },
  },
];

export default getSchema;
